import { Alert, Button, Form, Input } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";
import { useState } from "react";
import { BrandMark } from "../components/BrandMark";
import { ApiError, useAuth } from "../hooks/useAuth";

type FormValues = { username: string; password: string };

export function LoginPage() {
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onFinish = async (values: FormValues) => {
    setError(null);
    setSubmitting(true);
    try {
      await login(values.username, values.password);
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        setError("账号或密码错误");
      } else {
        setError("登录失败,请稍后重试");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "grid",
        placeItems: "center",
        padding: 24,
        background:
          "radial-gradient(circle at 20% 20%, color-mix(in srgb, var(--ant-color-primary) 16%, transparent), transparent 60%), radial-gradient(circle at 80% 80%, color-mix(in srgb, var(--ant-color-primary) 10%, transparent), transparent 60%), var(--ant-color-bg-layout)",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        style={{
          width: "min(420px, 100%)",
          padding: "40px 32px",
          background: "var(--ant-color-bg-container)",
          border: "1px solid var(--ant-color-border)",
          borderRadius: 16,
          boxShadow: "0 24px 48px -24px rgba(15, 17, 21, 0.18)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 24,
          }}
        >
          <BrandMark size={40} />
        </div>
        <h1
          style={{
            fontSize: 26,
            fontWeight: 700,
            margin: "0 0 8px",
            letterSpacing: -0.4,
            textAlign: "center",
          }}
        >
          欢迎回来
        </h1>
        <p
          style={{
            fontSize: 16,
            color: "var(--ant-color-text-secondary)",
            margin: "0 0 28px",
            lineHeight: 1.6,
            textAlign: "center",
          }}
        >
          使用管理员账号登录,管理预先配置好的 Gmail 邮箱。
        </p>

        {error ? (
          <Alert
            type="error"
            message={error}
            showIcon
            style={{ marginBottom: 16, borderRadius: 10 }}
          />
        ) : null}

        <Form<FormValues>
          layout="vertical"
          requiredMark={false}
          onFinish={onFinish}
          initialValues={{ username: "admin" }}
          autoComplete="on"
        >
          <Form.Item
            name="username"
            label="账号"
            rules={[{ required: true, message: "请输入账号" }]}
          >
            <Input
              size="large"
              prefix={
                <UserOutlined
                  style={{ color: "var(--ant-color-text-secondary)" }}
                />
              }
              placeholder="admin"
              autoComplete="username"
            />
          </Form.Item>
          <Form.Item
            name="password"
            label="密码"
            rules={[{ required: true, message: "请输入密码" }]}
          >
            <Input.Password
              size="large"
              prefix={
                <LockOutlined
                  style={{ color: "var(--ant-color-text-secondary)" }}
                />
              }
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              loading={submitting}
              style={{ height: 48, fontWeight: 500 }}
            >
              登录
            </Button>
          </Form.Item>
        </Form>
      </motion.div>
    </div>
  );
}
